<div class="folder-edit">
  <h2 mat-dialog-title>Change folder name</h2>

  <mat-dialog-content [formGroup]="formGroup">
    <mat-form-field>
      <mat-label>New folder name</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="clear()">Clear</button>
    <button mat-flat-button (click)="change()">Change</button>
  </mat-dialog-actions>
</div>
